import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { getDefaultAssignableExpressionSchema } from '../../../../expressions/repository/assignable/AssignableExpressionSchema.ts';
import { ValueExpressionType } from '../../../../expressions/repository/value/ValueExpression.type.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { ConfirmationConfigInput } from '../../advanced/confirm/shared/ConfirmationConfigInput.tsx';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { WidgetConfigurationSlots } from '../../common/config-slots/WidgetConfigurationSlots.tsx';
import {
  DefaultValueInput,
  useDefaultValueField,
} from '../../common/DefaultValueInput.tsx';
import { CodeLabelInputForm } from '../common/CodeLabelInputForm.tsx';
import { CommonHelpTextsInputConfigSubCard } from '../common/CommonHelpTextsInputConfigSubCard.tsx';
import { CommonInputWidgetConfigSchema } from '../common/CommonInputConfigComponent.tsx';
import { LabelLayoutConfigInput } from '../common/label-layout/LabelLayoutConfigInput.tsx';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type IBooleanWidget } from './IBooleanWidget.ts';

export const BooleanWidgetConfigSchema: yup.ObjectSchema<IBooleanWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Boolean).required(),
    text: RichTextAdvancedSchema.optional().label('Testo'),
    // Forzo l'impostazione del valore di default a false per evitare che sia undefined, dando problemi con le regole.
    defaultValue: getDefaultAssignableExpressionSchema({
      ...ValueExpressionType.schema.getDefault(),
      value: false,
    }),
  });

export interface IBooleanConfigComponentProps
  extends IWidgetComponentProps<IBooleanWidget> {}

/**
 * Form di configurazione widget boolean (checkbox/switch).
 * Come il common ma non ha il placeholder.
 */
export function BooleanConfigComponent(props: IBooleanConfigComponentProps) {
  const options = getWidgetProps(props);
  const defaultValueField = useDefaultValueField();

  return (
    <div>
      {/* Form Codice + Etichetta */}
      <CodeLabelInputForm widgetOptions={options} />

      <FormItem
        name="text"
        label="Testo"
        help={
          <>
            Il <b>Testo</b> è mostrato accanto alla casella di selezione;
            l&apos;Etichetta resta sopra il campo.
          </>
        }
      >
        <RichTextAdvancedInput
          name="text"
          rows={2}
          menus={MenuPresets.Minimal}
        />
      </FormItem>

      <CommonHelpTextsInputConfigSubCard hidePlaceholder />

      {/* Disposizione etichetta nella card Aspetto e Layout */}
      <WidgetConfigurationSlotRender
        slot={WidgetConfigurationSlots.Layout}
        order={20}
      >
        <LabelLayoutConfigInput />
      </WidgetConfigurationSlotRender>

      {defaultValueField && (
        <WidgetConfigurationSlotRender
          slot={WidgetConfigurationSlots.Default}
          order={10}
        >
          <DefaultValueInput />
          <ConfirmationConfigInput name="confirmation" />
        </WidgetConfigurationSlotRender>
      )}
    </div>
  );
}
